/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable max-lines-per-function */
import React, { useEffect } from 'react';
import { Box, Skeleton } from 'native-base';
import { fakeItemsArray, useGetRedeemRewards, useGetVisits, useI18n, useSpringBigStore } from '@springbig/shared';
import Section from '~/shared/Section';
import { Caption } from '~/shared/Typography';
import AccountHistoryPurchaseCard from './components/AccountHistoryPurchaseCard';
import AccountHistoryRedemptionCard from './components/AccountHistoryRedemptionCard';
import { useAccountHistoryStyles } from '~/shared/styles';
import Pressable from '~/shared/Pressable';
import { useAuthorization } from '~/hooks/auth';
import { NoDataPlaceholder } from '~/shared/NoDataPlaceholder';
import { faAward, faShoppingCart } from '@fortawesome/free-solid-svg-icons';

const AccountHistoryScreen = () => {

    const { t } = useI18n();
    const { member } = useSpringBigStore();

    const {
        active_button_background,
        active_button_text,
        inactive_button_background,
        inactive_button_text,
    } = useAccountHistoryStyles();

    const [toggleView, setToggleView] = React.useState<'purchases' | 'redemptions'>('purchases');
    const {
        data: visits,
        isLoading: isLoadingVisits,
        refetch: refetchVisits,
    } = useGetVisits();
    const {
        data: rewards,
        isLoading: isLoadingRewards,
        refetch: refetchRewards,
    } = useGetRedeemRewards();

    useEffect(() => {
        refetchVisits();
        refetchRewards();
    }, [member]);

    const { isLoadingAuth } = useAuthorization();

    const tabView = (
        <>
            <Box
                mb={4}
                flexDirection={'row'}
                alignItems="center"
                justifyContent={'space-between'}
            >
                <Pressable
                    onPress={() => setToggleView('purchases')}
                    w={'50%'}
                    bg={
                        toggleView === 'purchases'
                            ? active_button_background
                            : inactive_button_background
                    }
                    h={10}
                    alignItems="center"
                    justifyContent={'center'}
                >
                    <Caption
                        text="history.title_purchases"
                        color={
                            toggleView === 'purchases'
                                ? active_button_text
                                : inactive_button_text
                        }
                    />
                </Pressable>
                <Pressable
                    onPress={() => setToggleView('redemptions')}
                    w={'50%'}
                    h={10}
                    alignItems="center"
                    justifyContent={'center'}
                    bg={
                        toggleView === 'redemptions'
                            ? active_button_background
                            : inactive_button_background
                    }
                >
                    <Caption
                        text="history.title_redemptions"
                        color={
                            toggleView === 'redemptions'
                                ? active_button_text
                                : inactive_button_text
                        }
                    />
                </Pressable>
            </Box>
        </>
    );

    const isLoading = isLoadingVisits || isLoadingRewards || isLoadingAuth;

    if (!member || isLoading) {
        return (
            <Section flex={1}>
                {tabView}
                <AccountHistoryCardSkeleton />

            </Section>
        );
    }

    if (toggleView === 'redemptions' && (!rewards || !rewards.length) && !(isLoading) && member) {
        return (
            <NoDataPlaceholder
                header={
                    <Box>
                        {tabView}
                    </Box>
                }
                title={t('common.redemptions_placeholder_title')}
                message={t('common.redemptions_placeholder_subtitle')}
                callback={refetchRewards}
                isLoading={isLoadingVisits}
                iconName={faAward}
                flexGrow={0}
            />
        );
    }

    if (toggleView === 'purchases' && (!visits || !visits.length) && !(isLoading) && member) {
        return (
            <NoDataPlaceholder
                header={
                    <Box>
                        {tabView}
                    </Box>
                }
                title={t('common.purchases_placeholder_title')}
                message={t('common.purchases_placeholder_subtitle')}
                callback={refetchVisits}
                isLoading={isLoadingVisits}
                iconName={faShoppingCart}
                flexGrow={0}
            />
        );
    }

    return (
        <Section flex={1}>
            {tabView}
            {
                (isLoading || !member) ? <AccountHistoryCardSkeleton /> : <Box mb={4}>
                    {
                        (toggleView === 'purchases' && visits && visits.length > 0) && visits.map((visit, index) => (

                            <AccountHistoryPurchaseCard key={index} visit={visit} />
                        ))
                    }
                    {
                        (toggleView === 'redemptions' && rewards && rewards.length > 0) && rewards.map((redeemed, index) => (

                            <AccountHistoryRedemptionCard key={index + 200} redeemed={redeemed} />
                        ))
                    }
                </Box>
            }

        </Section>
    );
};

const AccountHistoryCardSkeleton = () => {

    return (
        <Box mx={2}>
            {fakeItemsArray.map((index) => (
                <Skeleton key={index} h={'5rem'} rounded={'lg'} mb={2} w='100%' />
            ))}
        </Box>
    );
};

export default AccountHistoryScreen;
